<!-- #94: personalization consent. Deliberately NOT gated on profile?.isActive like the
     other sections' save buttons: consent must be withdrawable at any time and without
     disadvantage (Art. 7(3)), which an inactive profile is no exception to. -->
<form [formGroup]="form">
  <div class="mt-5">
    <h3 i18n="@@settings.personalization.heading">Personalisierung</h3>
    <hr />
    <p class="text-muted small" i18n="@@settings.personalization.explanation">
      Wenn persönliche Empfehlungen eingeschaltet sind, speichert GetLocal Ihre
      Suchbegriffe und die von Ihnen angesehenen Artikel, um Ihnen auf der Startseite
      passende Angebote vorzuschlagen. Es wird dafür kein externer KI-Dienst genutzt.
      Die Einstellung gehört zu Ihrem Benutzerkonto und gilt daher auf allen Geräten.
      Ihre Merkliste wird unabhängig davon angezeigt.
    </p>
    <div class="form-check">
      <input
        id="personalizationEnabled"
        type="checkbox"
        class="form-check-input"
        formControlName="personalizationEnabled"
        data-testid="settings-personalization-enabled"
        />
      <label class="form-check-label" for="personalizationEnabled" i18n="@@settings.personalization.switch">
        Persönliche Empfehlungen
      </label>
    </div>
    <p class="text-muted small mt-2" i18n="@@settings.personalization.offWarning">
      Beim Ausschalten wird Ihr gespeicherter Verlauf gelöscht.
    </p>

    <div class="mt-3">
      <button
        class="btn btn-primary m-2"
        type="button"
        data-testid="settings-personalization-save"
        [asyncClick]="save.bind(this)"
        [disabled]="saveBtn.disabled || form.pristine"
        #saveBtn="asyncClick"
        i18n
        >
        @if (saveBtn.busy) { <span class="spinner-border spinner-border-sm me-1"></span> }
        Einstellungen speichern
      </button>

      <!-- Art. 17, and separate from the switch on purpose: this one leaves
           personalization ON. -->
      <button
        class="btn btn-outline-secondary m-2"
        type="button"
        data-testid="settings-personalization-delete-history"
        [asyncClick]="deleteHistory.bind(this)"
        [disabled]="deleteHistoryBtn.disabled"
        #deleteHistoryBtn="asyncClick"
        i18n="@@settings.personalization.delete"
        >
        @if (deleteHistoryBtn.busy) { <span class="spinner-border spinner-border-sm me-1"></span> }
        Verlauf löschen
      </button>

      <button
        class="btn btn-link m-2"
        type="button"
        data-testid="settings-personalization-history-toggle"
        [attr.aria-expanded]="historyVisible"
        (click)="toggleHistory()"
        >
        @if (historyVisible) {
          <ng-container i18n="@@settings.personalization.hideData">Gespeicherte Daten ausblenden</ng-container>
        } @else {
          <ng-container i18n="@@settings.personalization.showData">Gespeicherte Daten anzeigen</ng-container>
        }
      </button>
    </div>

    <!-- Art. 15: the raw stored signals, not the tiles derived from them. -->
    @if (historyVisible) {
      <div class="mt-3" data-testid="settings-personalization-history">
        @if (historyLoading) {
          <p class="text-muted" i18n="@@settings.personalization.dataLoading">Daten werden geladen…</p>
        } @else if (!history || (history.searches.length === 0 && history.visits.length === 0)) {
          <p class="text-muted" i18n="@@settings.personalization.dataEmpty">
            Zu Ihrem Benutzerkonto ist derzeit kein Verlauf gespeichert.
          </p>
        } @else {
          <h5 i18n="@@settings.personalization.dataSearches">Gespeicherte Suchbegriffe</h5>
          @if (history.searches.length === 0) {
            <p class="text-muted small" i18n="@@settings.personalization.dataNoSearches">Keine</p>
          } @else {
            <ul class="list-unstyled">
              @for (search of history.searches; track search.term) {
                <li>
                  <span class="me-2">{{ search.term }}</span>
                  <span class="text-muted small">{{ search.searchedAt | date: 'short' }}</span>
                </li>
              }
            </ul>
          }

          <h5 class="mt-3" i18n="@@settings.personalization.dataVisits">Angesehene Artikel</h5>
          @if (history.visits.length === 0) {
            <p class="text-muted small" i18n="@@settings.personalization.dataNoVisits">Keine</p>
          } @else {
            <ul class="list-unstyled">
              @for (visit of history.visits; track visit.catalogSkuId) {
                <li>
                  <a [routerLink]="['/catalog-item', visit.catalogSkuId]" class="me-2">{{ visit.catalogSkuId }}</a>
                  <span class="text-muted small">{{ visit.visitedAt | date: 'short' }}</span>
                </li>
              }
            </ul>
          }
        }
      </div>
    }
  </div>
</form>
